import { css, type SerializedStyles } from '@emotion/react'
import { type Theme } from '@mui/material/styles'
import { rem } from 'polished'

export const content = (theme: Theme): SerializedStyles =>
  css({
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(3, 3, 2),
  })

export const illustration = (theme: Theme): SerializedStyles =>
  css({
    alignSelf: 'center',
    marginBottom: theme.spacing(1),
  })

export const annotations = (theme: Theme): SerializedStyles =>
  css({
    color: theme.palette.text.secondary,
    paddingTop: theme.spacing(1),
    whiteSpace: 'pre-line',
  })

export const actions = (theme: Theme): SerializedStyles =>
  css({
    marginLeft: `calc(-${theme.spacing(2)} + ${rem(1)})`, // According to figma rules
    marginRight: `calc(-${theme.spacing(2)} + ${rem(1)})`, // According to figma rules
    marginTop: theme.spacing(3),
    width: `calc(100% - calc(-${theme.spacing(2)} + ${rem(1)}) * 2)`,
  })

export const linksWrapper = (isColumn: boolean): SerializedStyles =>
  css(
    {
      display: 'flex',
    },
    isColumn
      ? {
          alignItems: 'flex-end',
          flexDirection: 'column',
        }
      : {
          flexDirection: 'row',
          justifyContent: 'flex-end',
        },
  )
